import React from "react"

import { PageContentWrapper } from "~/shared-components"

export const Dashboard: React.FC = () => {
	return <PageContentWrapper heading="Dashboard" />
}
